import React, { useCallback, useEffect, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import SalesTrainingCompaniesList from './SalesTrainingCompanies';
import AddEditIndividual from './AddEdit';
import { getSalesTrainingCompanyList } from '../../../../redux/SalesTrainingCompanies/SalesTrainingCompaniesslice';
import { selectSalesTrainingCompanyList, selectSalesTrainingCompanyListTotal, selectSalesTrainingCompanyListLoading } from '../../../../redux/SalesTrainingCompanies/SalesTrainingCompaniesselectors';

const SalesTrainingCompanies = () => {
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);

  const list = useSelector(selectSalesTrainingCompanyList);
  const totalCount = useSelector(selectSalesTrainingCompanyListTotal);
  const loading = useSelector(selectSalesTrainingCompanyListLoading);

  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  const totalPages = Math.ceil(totalCount / filterlimit);

  const handleSearch = (e) => {
    SetFilterData((prevalue) => ({
      ...prevalue,
      [e.target.name]: e.target.value.trim(),
    }));
    setfilterpage(1);
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Sales Training Companies",
          url: "/salesTrainingCompanies",
          home: "/dashboard",
        },
      ])
    );
  }, [dispatch]);

  const fetchData = useCallback(() => {
    dispatch(getSalesTrainingCompanyList({
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search,
      access_group_id: 6
    }));
  }, [dispatch, filterpage, filterlimit, getFilterData.search]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  const handlePageChange = (page) => {
    setfilterpage(page);
  };

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3"></p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading>Sales Training Companies</Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={() => setDialogOpen(true)}
            className="h-9 flex items-center justify-center gap-1"
            style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
          >
            Add Sales
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.712 4.167v11.666M4.878 10h11.667" stroke="#fff" strokeWidth="1.667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img src="/assets/icons-svg/search-lg.svg" alt="" className="h-5" />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      <SalesTrainingCompaniesList sampleData={list} loading={loading} onRefresh={fetchData} />

      <AddEditIndividual
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          fetchData();
        }}
      />

      <div className="flex justify-between items-center mt-3">
        <Pagination
          totalCount={totalCount}
          pageNumber={filterpage}
          displayPage={list?.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {totalCount > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default SalesTrainingCompanies;
